var exports = {
  "Qs": "x4c3adb35--cbfdfc--content",
  "Hw": "x4c3adb35--cbfdfc--mobile",
  "Sl": "x4c3adb35--cbfdfc--image",
  "R_": "x4c3adb35--cbfdfc--heading",
  "ne": "x4c3adb35--cbfdfc--controls",
};

module.exports = exports;
